import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-background">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 rounded-full border-4 border-gray-200 border-t-primary animate-spin" />
          <span className="text-text-muted text-sm">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(user.permisos)) {
    return (
      <div className="flex justify-center items-center h-screen bg-background">
        <div className="text-center p-8 bg-surface rounded-lg shadow-md">
          <h1 className="text-2xl font-bold text-danger mb-2">Acceso denegado</h1>
          <p className="text-text-muted">No tiene permisos para acceder a esta página.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
